import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NextButton({
  step,
  isDone,
  onClick
}) {
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "80%",
    children: /*#__PURE__*/_jsxs(Button, {
      "data-test-id": "next-button",
      use: "primary",
      onClick: onClick,
      paddingInline: "300",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `app.wizard.footer.next.${step}.nextStep`
      }), !isDone && /*#__PURE__*/_jsx(RightIcon, {})]
    })
  });
}